<template>
  <div>
    <MatterInfo ref="matterInfo" :title="title" :tag="tag" :itemId="itemId">
      <div slot="content">
        <div class="swiperBox" style="margin-top: 40px">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="信息确认" >
              <a-alert message="若要修改，点击“上一步”到达对应位置进行修改" type="info" class="word1" show-icon />
              <div v-if="model">
                <div class="title" >
                  <span class="tip">填报信息</span>
                </div>
                <div style="margin-top: 20px">
                  <h-meta-view
                    :value="model"
                    :template="showDesignData.formTemplate"
                    :meta="showDesignData.formMeta"
                    :borderShow="showDesignData.pageConfig.borderShow"
                    :layout="showDesignData.pageConfig.layout"
                    :labelAlign="showDesignData.pageConfig.labelAlign"
                    :labelWidth="showDesignData.pageConfig.labelWidth"
                  />
                </div>
              </div>
              <div>
                <div class="title">
                  <span class="tip">上传材料</span>
                </div>
                <div v-if="materialData && materialData.length > 0">
                  <div v-for="(item, index) in materialData" :key="index">
                    <div class="itemName" style="margin-top: 20px">{{ item.name || item.materialName }}</div>
                    <div v-if="item && item.data && item.data.length > 0">
                      <a-row>
                        <a-col
                          :span="8"
                          v-for="(ele, index2) in item.data"
                          :key="index2"
                          class="itemData"
                        >
                          <div
                            style="
                              height: 88px;
                              width: 88px;
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              overflow: hidden;
                            "
                          >
                            <img alt="" :src="ele.base64 || ele.thumbUrl" style="width: 100%" />
                          </div>
                        </a-col>
                      </a-row>
                    </div>
                    <div v-if="!item.data || item.data.length === 0" style="font-size: 16px;color: #333;margin-top: 20px;">未上传</div>
                  </div>
                </div>
                <div v-else style="font-size: 16px;color: #333;margin-top: 20px;">
                  未上传
                </div>
              </div>
              <div v-if="receiveParams" style="margin-top: 30px;">
                <div class="title">
                  <span class="tip">取件方式</span>
                </div>
                <div class="uploadMaterial">
                  <span>
                    {{ receiveType }}
                  </span>
                  <br />
                  <span v-if="receiveType === '邮寄'">
                    {{ receiveUserName }}
                    <br />
                    {{ receivePhone }}
                    <br />
                    {{ receiveDetailArea }}
                  </span>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>

          <div style="text-align: right">
            <a-button style="height: 40px; width: 150px" type="default" @click="previousStep">
              上一步
            </a-button>
            <a-tooltip style="margin-left: 10px">
              <template slot="title">
                <span>申请表会暂存到个人中心的办事记录中，可再次编辑</span>
              </template>
              <a-button
                style="height: 40px; width: 150px; margin-right: 10px; margin-left: 10px"
                type="default"
                @click="saveDraft"
              >
                保存为草稿
                <a-icon type="info-circle" />
              </a-button>
            </a-tooltip>
            <a-button
              style="height: 40px; width: 150px"
              type="primary"
              @click="nextStep"
              v-if="stepNo < total - 1"
            >
              下一步
            </a-button>
            <SubmitButton />
          </div>
        </div>
      </div>
    </MatterInfo>
  </div>
</template>
<script>
import HMetaForm from 'jpaas-component/lib/HMetaForm'
import MatterInfo from '@/views/jiopweb/onlineDealWith/layout/matterInfo.vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { jiopWebAPI } from '@/api/jiopweb/gzy-jiopweb'
import { sm2 } from 'sm-crypto'
import SubmitButton from '@/views/jiopweb/onlineDealWith/components/submitButton.vue'
import HMetaView from 'jpaas-component/lib/HMetaView'
import cloneDeep from 'lodash.clonedeep'
export default {
  name: 'MatterFrom',
  components: {
    MatterInfo,
    HMetaForm,
    SubmitButton,
    HMetaView
  },
  created () {
    this.getSessionInfo2()
    this.getSessionInfo()
  },
  data () {
    return {
      zhCN,
      title: JSON.parse(sessionStorage.getItem(this.$route.query.itemId + '_matter')).matterName,
      tag: JSON.parse(sessionStorage.getItem(this.$route.query.itemId + '_matter')).tag,
      formData: { formTemplate: '', formConfig: {} },
      showFormData: {},
      showDesignData: {
        formTemplate: [],
        pageConfig: {},
        formMeta: {}
      },
      model: {},
      cardLoading: false,
      pageNo: 1,
      matterId: '1a1b805b2f6345eebac132385a9cb429',
      visible: false,
      visible2: false,
      itemId: this.$route.query.itemId,
      stepNo: this.$route.query.stepNo,
      total: this.$route.query.total,
      receiveUserName: null,
      receivePhone: null,
      receiveDetailArea: null,
      receiveType: null,
      materialData: [],
      receiveParams: {},
      publicKey: '',
      dimensionMap: new Map(),
      formArray: []
    }
  },
  methods: {
    getSessionInfo () {
      this.materialData = sessionStorage.getItem(this.itemId + '_JiopwebMaterial')
        ? JSON.parse(sessionStorage.getItem(this.itemId + '_JiopwebMaterial'))
        : []
      console.log(this.materialData, '000000')
      this.materialData.forEach((item, index) => {
        item && item.data && item.data.forEach((ele, index) => {
          ele.status = 'done'
          ele.uid = index
          ele.percent = 100
          if (ele.base64) {
            // ele.thumbUrl = 'data:image/png;base64,' + ele.base64
            ele.thumbUrl = ele.base64
          } else {
            if (ele.oldFileName) {
              const type = ele.oldFileName.substring(ele.oldFileName.lastIndexOf('.') + 1)
              if (type === 'doc' || type === 'docx') {
                // doc和docx
                ele.thumbUrl = 'data:image/png;base64,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'
              } else if (type === 'pdf') {
                // pdf
                ele.thumbUrl = 'data:image/png;base64,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'
              } else if (type === 'xlsx') {
                // xlsx
                ele.thumbUrl = 'data:image/png;base64,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'
              }
            }
          }
          ele.name = ele.oldFileName
        })
      })
      this.receiveParams = sessionStorage.getItem(this.itemId + '_JiopwebReceive')
        ? JSON.parse(sessionStorage.getItem(this.itemId + '_JiopwebReceive'))
        : {}
      if (this.receiveParams) {
        if (parseInt(this.receiveParams.receiveType) === 1) {
          this.receiveType = '邮寄'
          this.receiveUserName = '收件姓名: \u3000 ' + this.receiveParams.receiveUserName
          this.receivePhone = '收件号码: \u3000 ' + this.receiveParams.receivePhone
          this.receiveDetailArea =
            '详细地址: \u3000 ' +
            JSON.parse(this.receiveParams.receiveArea).join('') +
            this.receiveParams.receiveDetailArea
        } else {
          this.receiveType = '自取'
        }
      }
    },
    getSessionInfo2 () {
      const that = this
      const listOfSituations = sessionStorage.getItem(this.itemId + '_listOfSituations') ? JSON.parse(sessionStorage.getItem(this.itemId + '_listOfSituations')) : ''
      const situationIds = []
      if (listOfSituations && listOfSituations.length > 0) {
        listOfSituations.forEach((item, index) => {
          if (item.checked !== '') {
            situationIds.push(item.checked)
          }
        })
      }
      const situationIdsString = situationIds.join(',')
      jiopWebAPI.findMaterialByIids({ itemId: that.itemId, situationIds: situationIdsString }).then(res => {
        if (res.success) {
          // this.formData = JSON.parse(res.data.formDesign)
          const params = sessionStorage.getItem(this.itemId + '_infoStr') ? JSON.parse(sessionStorage.getItem(this.itemId + '_infoStr')) : ''
          const formDataArr = params ? JSON.parse(params) : undefined

          let metaIds = []
          const showFormDataObj = {}; const lastFormObj = {}
          if (formDataArr) {
            formDataArr.formData.forEach(item => {
              showFormDataObj[item.fieldName] = item.fieldValueTitle || item.fieldValue
              lastFormObj[item.fieldName] = item.fieldValueTitle || item.fieldValue // 上一页中保存的表单信息
              // 组合需要解析的元数据
              if (item.fieldValue.length >= 10) {
                metaIds.push(item.fieldValue)
              } else if (Array.isArray(item.fieldValue)) {
                item.fieldValue.map(item => {
                  metaIds.push(item)
                })
              }
            })
          }
          metaIds = metaIds.join(',')
          jiopWebAPI.findMetaData({ metaIds: metaIds }).then(res2 => {
            if (res2.success) {
              that.dimensionMap = res2.data.dimensionMap
              formDataArr.formData.forEach(item => {
                console.log('isArray', Array.isArray(item.fieldValue))
                if (Array.isArray(item.fieldValue)) {
                  let str = ''
                  item.fieldValue.map(metaItem => {
                    for (const key in that.dimensionMap) {
                      if (metaItem === key) {
                        const value = that.dimensionMap[key]
                        if (str) {
                          str = str + ',' + value
                        } else {
                          str = value
                        }
                      }
                    }
                  })
                  showFormDataObj[item.fieldName] = str
                } else {
                  showFormDataObj[item.fieldName] = that.dimensionMap[item.fieldValue]
                }
              })
              this.model = cloneDeep(showFormDataObj)
              const showDesignData = res.data.showDesign ? JSON.parse(res.data.showDesign) : {}
              if (showDesignData) {
                this.showDesignData.pageConfig = showDesignData.pageConfig
                this.showDesignData.formTemplate = showDesignData.formTemplate
                this.showDesignData.formMeta = showDesignData.formMeta
                this.showDesignData.formConfig = showDesignData.formConfig
                this.showDesignData.associated = showDesignData.associated
              }
              Object.keys(this.model).forEach((item) => {
                if (!this.model[item]) {
                  if (this.showDesignData.formMeta[item]?.type === 'Date') {
                    this.model[item] = lastFormObj[item] ? lastFormObj[item] : ''
                  } else {
                    this.model[item] = (lastFormObj[item] || lastFormObj[item] === 0) ? lastFormObj[item] : '未填写'
                  }
                }
              })
            }
          })
        }
      })
    },
    saveDraft () {
      const that = this
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = userInfo.desensitizeUser ? JSON.parse(userInfo.desensitizeUser) : {}
          const usreId = userParams.uid ? userParams.uid : ''
          // jiopWebAPI.getPublicKey({ userId: usreId }).then(res => {
          jiopWebAPI.getPublicKey({ userType: 1, appType: 1 }).then(res => {
            if (res.success) {
              that.publicKey = res.data.publicKey
              const encryptString = this.submitDataHandle()
              jiopWebAPI.materialSubmit({ infoStr: encryptString, applyUserId: usreId }).then(res => {
                if (res.success) {
                  that.$message.success('已经存为草稿，请到用户空间-我的办件中查看')
                }
              })
            }
          })
        }
      }
    },
    previousStep () {
      this.$refs.matterInfo.previousStep()
    },
    nextStep () {
      this.$refs.matterInfo.nextStep()
    },
    submitDataHandle () {
      const that = this
      const jsonParams = sessionStorage.getItem(this.itemId + '_matter') ? JSON.parse(sessionStorage.getItem(this.itemId + '_matter')) : {} // 事项数据
      // 用户信息
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = userInfo.desensitizeUser ? JSON.parse(userInfo.desensitizeUser) : {}
          jsonParams.applyUserId = userParams.uid ? userParams.uid : undefined
          jsonParams.applyUserName = userParams.name ? userParams.name : undefined // 姓名是加密发回的带星号
        }
      }
      jsonParams.steps = this.stepNo // 进度条
      jsonParams.situationSelect = sessionStorage.getItem(this.itemId + '_listOfSituations') // 情形选择
      jsonParams.formData = sessionStorage.getItem(this.itemId + '_infoStr') // 信息填报
      // 信息填报回显用（提交草稿是要传）
      jsonParams.model = sessionStorage.getItem(this.itemId + '_model')
      jsonParams.reportingprogress = '100'
      jsonParams.handleType = this.$route.query.handleType
      const uploadInfo = sessionStorage.getItem(this.itemId + '_JiopwebMaterial') ? JSON.parse(sessionStorage.getItem(this.itemId + '_JiopwebMaterial')) : []
      uploadInfo.forEach(item => {
        if (item.data && item.data.length > 0) {
          item.data.forEach(ele => {
            ele.base64 = ''
            ele.thumbUrl = ''
          })
        }
      })
      jsonParams.uploadMaterial = JSON.stringify(uploadInfo) // 材料
      // 取件方式
      this.receiveParams = sessionStorage.getItem(this.itemId + '_JiopwebReceive')
      if (this.receiveParams) {
        if (parseInt(this.receiveParams.receiveType) === 1) {
          jsonParams.receiveType = 1
          jsonParams.receiveUserName = this.receiveParams.receiveUserName
          jsonParams.receivePhone = this.receiveParams.receivePhone
          jsonParams.receiveArea = this.receiveParams.receiveArea
          jsonParams.receiveDetailArea = this.receiveParams.receiveDetailArea
        } else {
          jsonParams.receiveType = 0
        }
      }
      const jsonstring = JSON.stringify(jsonParams)
      const encryptString = that.encrypt(jsonstring, this.publicKey)
      return encryptString
    },
    encrypt: function (str, publicKey) {
      return '04' + sm2.doEncrypt(str, publicKey, 1)
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: auto;
}
.swiperBox {
  box-shadow: 0px 2px 15px 0px rgba(153, 153, 153, 0.2);
  width: 1200px;
  // height: 120px;
  background: #ffffff;
  padding: 37px;
  margin: auto;
}
.btnStyle1 {
  height: 40px;
  display: inline-block;
  color: #fff;
  background: #1677ff;
  line-height: 40px;
  text-align: center;
  border: 1px solid #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 150px;
  margin-left: 20px;
}
.btnStyle2 {
  height: 40px;
  width: 150px;
  margin-left: 20px;
  line-height: 40px;
  text-align: center;
  border: 1px solid rgba(23, 119, 255, 1);
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  color: #1677ff;
}

.uploadMaterial {
  margin-top: 30px;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
}
.tip {
  margin-left: 8px;
  width: 80px;
height: 22px;

font-size: 20px;
color: #333333;
line-height: 22px;
font-weight: 600;
}
/deep/ .ant-tabs-ink-bar {
  position: absolute;
  bottom: 1px;
  left: 0;
  z-index: 1;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 0;
  height: 2px;
  background-color: #1677ff;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
/deep/ .ant-tabs-nav .ant-tabs-tab {
  position: relative;
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 100%;
  margin: 0 32px 0 0;
  padding: 0px 4px 19px 4px;
  text-decoration: none;
  cursor: pointer;
  -webkit-transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 22px;
  font-weight: 600;
}
/deep/ .ant-tabs-nav .ant-tabs-tab-active {
  color: #1677ff;
  text-shadow: 0 0 0.25px currentColor;
}
/deep/ .ant-tabs-bar {
  margin: 0px 0 20px 0;
  border-bottom: 1px solid #e8e8e8;
  outline: none;
  -webkit-transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/deep/ .ant-alert-info {
    background-color: #EDF5FF;
    border: 1px solid #91d5ff;
    margin-bottom: 30px;
}
/deep/ .ant-alert-info .ant-alert-icon {
    color: #1677FF;
}
/deep/ .ant-alert-message {
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 400;
}
.itemName {
  height: 22px;

  font-size: 18px;
  color: #333333;
  line-height: 22px;
  font-weight: 600;
}
.itemData {
  width: 104px;
  height: 104px;
  background: #ffffff;
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 44px;
  margin-top: 20px;
}
.title {
  margin-top: 30px;
  border-left: 5px solid #1677ff;
  height: 22px;
  line-height: 22px;
}
.word1{
height: 40px;
background: #EDF5FF;
border: 1px solid rgba(151,195,255,1);
border-radius: 4px;
}
</style>
